import type { RouteLocationRaw } from 'vue-router'

export interface BackNavigationContext {
  backUrl: string | null
  currentUrl: string | null
}

export interface BackNavigationHook {
  shouldForceFallback: (ctx: BackNavigationContext) => boolean
  resolveFallback?: (
    ctx: BackNavigationContext,
    fallbackRoute: RouteLocationRaw,
  ) => RouteLocationRaw
}

const hooks: BackNavigationHook[] = []

export function registerBackNavigationHook(hook: BackNavigationHook) {
  hooks.push(hook)
}

export function applyBackNavigationHooks(
  ctx: BackNavigationContext,
  fallbackRoute: RouteLocationRaw,
): { forceFallback: boolean, fallbackRoute: RouteLocationRaw } {
  let forceFallback = false
  let resolvedFallback = fallbackRoute

  for (const hook of hooks) {
    if (!hook.shouldForceFallback(ctx)) {
      continue
    }

    forceFallback = true

    if (hook.resolveFallback) {
      resolvedFallback = hook.resolveFallback(ctx, resolvedFallback)
    }
  }

  return { forceFallback, fallbackRoute: resolvedFallback }
}
